import React from 'react'
import ProductExportModal from '../../../components/inventorymng/products/ProductExportModal'

const ProductExportModalContainer = ({ open, handleClose }) => {
  return (
    <ProductExportModal
      open={open}
      handleClose={handleClose}
    />
  )
}

export default ProductExportModalContainer